import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-side-panel-shell',
  imports: [
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    NgClass,
    NgTemplateOutlet,
  ],
  templateUrl: './side-panel-shell.component.html',
  styleUrls: ['./side-panel-shell.component.scss'],
  animations: [
    trigger('slideFixedInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
        })
      ),
      state(
        'out',
        style({
          transform: 'translateX(100%)',
        })
      ),
      transition('in => out', [animate('300ms ease-in-out')]),
      transition('out => in', [animate('300ms ease-in-out')]),
    ]),
    trigger('slideInOut', [
      state(
        'in',
        style({
          width: '375px',
          marginRight: '0px',
        })
      ),
      state(
        'out',
        style({
          width: '0',
          marginRight: '-375px',
        })
      ),
      transition('in => out', [animate('300ms ease-in-out')]),
      transition('out => in', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class SidePanelShellComponent {
  @Input() public useMobileView = false;
  @Input() public isOpened = false;
  @Input() public header = '';
  @Input() public hideContentOverflow = false;
  @Input({ required: true }) public contentTemplate!: TemplateRef<unknown>;
  @Output() public closePanel = new EventEmitter<void>();
}
